import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { thousandSeparator } from 'helpers/formatters'

import classes from './ProsAndConsSection.module.scss'
const ProsAndConsSection = ({ listing }) => {
  const { addEvent } = useEventContext()
  const positivePercentage = Math.round((listing.reviews?.by_rating[5] * 100) / (listing.reviews?.total || 1))
  const negativePercentage = Math.round(
    ((listing.reviews?.by_rating[1] + listing.reviews?.by_rating[2]) * 100) / (listing.reviews?.total || 1)
  )

  return (
    <>
      <Typography variant="heading-md" className={classes.subtitle}>
        Pros and cons based on {thousandSeparator(listing.reviews.total || 0)} verified reviews
      </Typography>
      <Typography>
        {positivePercentage}% of users rated {listing.name} 5 out of 5 stars, while {negativePercentage}% gave it 1 or 2
        stars. To determine these pros and cons insights we analyzed {thousandSeparator(listing.reviews.total || 0)}{' '}
        reviews and identified the topics where users expressed positive and negative sentiment.
      </Typography>
      <Grid container className={classes.prosConsContainer}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body-xs" className={classes.prosConsTitle}>
            Pros:
          </Typography>
          {listing.pros?.map(pro => (
            <div className={classes.proConText} key={`pro-${pro}`}>
              <Icon size={16} className={clsx(classes['iconPros'])} icon={'caret-circle-up'} />
              <Typography variant="body-xs">{pro}</Typography>
            </div>
          ))}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body-xs" className={classes.prosConsTitle}>
            Cons:
          </Typography>
          {listing.cons.map(con => (
            <div className={classes.proConText} key={`con-${con}`}>
              <Icon size={16} className={clsx(classes['iconCons'])} icon={'caret-circle-down'} />
              <Typography variant="body-xs">{con}</Typography>
            </div>
          ))}
        </Grid>
      </Grid>
      <Link
        className={classes.prosConsLink}
        href={`${listing.cta_urls.detail}#pros-cons`}
        {...addEvent({
          engagementComponent: 'best-product_card-item',
          engagementDetails: 'text-link_see-pros-and-cons',
          engagementDestination: 'go-to_product-details_pros-and-cons',
          name: 'engagement_product_click',
        })}
      >
        See pros and cons details
      </Link>
    </>
  )
}

export default ProsAndConsSection
